import { baseApi } from './baseApi';

export interface ExchangeRateDto {
  id: string;
  currencyCode: string;
  rateValue: number;
  isActive: boolean;
  createdAt: string;
}

export interface CreateExchangeRateDto {
  currencyCode: string;
  rateValue: number;
  isActive?: boolean;
}

export interface UpdateExchangeRateDto {
  currencyCode: 'USD' | 'EUR';
}

export const exchangeRateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getExchangeRates: builder.query<ExchangeRateDto[], void>({
      query: () => ({
        url: '/finance/exchange-rate',
        method: 'GET',
      }),
      providesTags: ['Finance'],
    }),
    getExchangeRateById: builder.query<ExchangeRateDto, string>({
      query: (id) => ({
        url: `/finance/exchange-rate/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Finance', id }],
    }),
    updateDefaultCurrency: builder.mutation<void, UpdateExchangeRateDto>({
      query: (body) => ({
        url: '/finance/exchange-rate-default/update',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Finance'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetExchangeRatesQuery,
  useGetExchangeRateByIdQuery,
  useUpdateDefaultCurrencyMutation,
} = exchangeRateApi;
